export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.browser) {
    const config = useRuntimeConfig()
    ;(window as any).GTM_ID = config.public.gtmID
  }
})
